import React from 'react'
import styled from 'styled-components'

export const BlackContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  font-family: inherit;
  background-image: url(${props => props.$bgImage});
  background-size: auto 100%;
  background-repeat: repeat-x;
  background-position: top;
  position: relative;

  @media (max-width: 768px) {
    background-image: url(${props => props.$bgMobile});
    background-position: top;
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.1);
    z-index: 1;
  }
`

export const MainSection = styled.div`
  flex: 1;
  display: grid;
  grid-template-rows: repeat(5, 1fr);
  align-items: center;
  justify-items: center;
  padding: 0 20px;
  position: relative;
  z-index: 2;
  text-align: center;
  min-height: 120vh;
`

export const ContentGrid = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`

export const HeroTitle = styled.h1`
  grid-row: 1;
  color: #fff;
  font-size: 3.5rem;
  font-weight: 800;
  margin: 0;
  text-transform: capitalize;
  letter-spacing: -0.5px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 1);
  font-family: 'Inter', sans-serif;
  z-index: 3;

  @media (max-width: 768px) {
    align-self: start;
    margin-top: 10px;
    letter-spacing: 0px;
    display: none;
  }
`

export const SearchSection = styled.div`
  grid-row: 2;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 450px;
  align-items: flex-start;
  margin-top: 20px;
  z-index: 3;

  @media (max-width: 768px) {
    max-width: 90%;
    align-self: center;
    position: absolute;
    top: -10.5%;
  }
`

export const HeroSubtitle = styled.p`
  color: #ff007c; /* Neon Pink */
  font-size: 1.1rem;
  font-weight: 900;
  margin: 0 0 10px 0;
  text-transform: uppercase;
  text-align: left;
  letter-spacing: 0.5px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 1);

  @media (max-width: 768px) {
    font-size: 1.2rem;
    margin-bottom: 8px;
  }
`

export const SearchWrap = styled.div`
  display: flex;
  align-items: center;
  background-color: rgba(20, 20, 20, 0.85);
  border: 1.5px solid #fff;
  border-radius: 10px;
  padding: 4px 15px;
  width: 100%;
  box-sizing: border-box;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0,0,0,0.6);
`

export const SearchInput = styled.input`
  background: transparent;
  border: none;
  color: #fff;
  font-size: 1.1rem;
  flex: 1;
  outline: none;
  padding: 10px 0;
  font-weight: 500;

  &::placeholder {
    color: #fff;
    opacity: 0.95;
  }
  @media (max-width: 768px) {
    height: 1.1rem;
  }
`

export const AddressUseLocation = styled.div`
  display: flex;
  align-items: center;
  color: #00f0ff; /* Bright Cyan */
  font-size: 1rem;
  font-weight: 900;
  text-transform: uppercase;
  cursor: pointer;
  margin-top: 12px;
  text-align: left;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 1);

  svg {
    margin-right: 8px;
    font-size: 1.2rem;
    color: inherit;
    filter: drop-shadow(2px 2px 2px rgba(0, 0, 0, 1));
  }

  @media (max-width: 768px) {
    font-size: 1.2rem;
    margin-top: 0px;
  }
`

export const ActionButtons = styled.div`
  grid-row: 3;
  display: flex;
  flex-direction: column;
  gap: 15px; /* Slightly tighter gap to match reference */
  width: 100%;
  max-width: 350px;
  z-index: 3;
  align-items: center;
  @media (max-width: 768px) {
    position: absolute;
    top: -15%;
    grid-row: 3;
    gap: 15px;
  }
`

export const CyanButton = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #00f0ff;
  color: #000;
  padding: 12px 25px;
  border-radius: 12px;
  font-weight: 900;
  font-size: 1.2rem;
  text-decoration: none;
  text-transform: uppercase;
  gap: 12px;
  width: 90%; /* Slightly less than 100% to match reference */
  box-sizing: border-box;
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.9);
  transition: transform 0.1s;
  border: none;

  /* Target the second button specifically */
  & + & {
    width: 50%;
    font-size: 1rem;
  }

  svg, img {
    font-size: 1.6rem;
    height: 20px;
    width: 20px;
  }

  &:active {
    transform: translateY(1px);
  }

  @media (max-width: 768px) {
    font-size: 1rem;
     width: 70%;
  }
`

export const LeftCol = styled.div``
export const RightCol = styled.div``
export const IconGrid = styled.div``
export const ActionIcon = styled.div``
export const SmallText = styled.span``
export const BrandWrap = styled.div``
export const BrandTitle = styled.h1``
export const BrandSub = styled.p``
export const LargeHeroImage = styled.div`display: none;`
export const ImageOverlayText = styled.h1``
export const BottomBar = styled.div`display: none;`
export const BottomText = styled.h2``
export const BottomBtn = styled.button``
export const HeroContainerStyled = styled.div`display: none;`
export const HeroContainer = (props) => {
  return <HeroContainerStyled {...props}>{props.children}</HeroContainerStyled>
}
export const ContentWrapper = styled.div``
export const Title = styled.h1``
export const Slogan = styled.p``
export const WrapInput = styled.div``
export const UseAccount = styled.div``
export const SectionHeader = styled.div``
export const LogoWrapper = styled.div``
export const HeroContent = styled.div``
